import { Check } from "lucide-react";
import { Link } from "react-router-dom";

const reviewBullets = [
  "Customer data leakage",
  "Tenant isolation and authorization flaws",
  "Prompt injection and jailbreak paths",
  "RAG and document exposure",
  "Unsafe tool or workflow access",
  "Sensitive data in prompts, responses, and logs",
  "Privacy and compliance evidence gaps",
];

const getBullets = [
  "Executive risk summary",
  "Technical findings",
  "Prioritized remediation roadmap",
  "Validation plan",
  "Evidence-ready documentation",
];

export default function ArqFrontDoorOffer() {
  return (
    <section id="ai-feature-security-review" className="bg-arq-bg py-20 md:py-[120px] px-6">
      <div className="max-w-[1100px] mx-auto">
        <div className="max-w-[820px] mb-10">
          <div className="arq-label mb-6">Front-Door Offer</div>
          <h2
            className="font-display font-semibold text-arq-text mb-5"
            style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}
          >
            AI Feature Security Review
          </h2>
          <p className="text-arq-muted text-[17px] leading-[1.75]">
            A focused review for teams launching chatbots, copilots, RAG search, AI agents, or AI
            workflow automation. ArqeraAI reviews the risks around data access, authorization,
            prompts, retrieval, logging, privacy, and compliance evidence before the feature
            reaches customers, auditors, or enterprise buyers.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-10">
          <div className="arq-card p-7">
            <div className="font-mono-tech text-[11px] tracking-[0.1em] uppercase text-arq-tertiary mb-4">
              What We Review
            </div>
            <ul className="space-y-3">
              {reviewBullets.map((it) => (
                <li key={it} className="flex items-start gap-3 text-[15px] text-arq-text/90 leading-snug">
                  <Check className="w-4 h-4 mt-1 flex-shrink-0 text-arq-teal" aria-hidden />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="arq-card p-7">
            <div className="font-mono-tech text-[11px] tracking-[0.1em] uppercase text-arq-tertiary mb-4">
              What You Get
            </div>
            <ul className="space-y-3">
              {getBullets.map((it) => (
                <li key={it} className="flex items-start gap-3 text-[15px] text-arq-text/90 leading-snug">
                  <Check className="w-4 h-4 mt-1 flex-shrink-0 text-arq-teal" aria-hidden />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <Link
            to="/ai-feature-security-review"
            className="bg-arq-blue text-white font-semibold text-[15px] px-8 py-4 rounded-md hover:bg-arq-blue-bright hover:shadow-[0_0_24px_rgba(26,111,212,0.35)] transition-all duration-150 tracking-[0.01em] text-center"
          >
            See the Full Review Scope
          </Link>
        </div>
      </div>
    </section>
  );
}
